export default __webpack_public_path__ + "static/media/bel.8a517feb.jpg";